<template>
	<v-card>
		<v-card-text>
			<v-layout>
				<a @click="$emit('job-click', JSON.parse(block.blockId))">
					<span class="font-weight-black"> Job: </span>{{ block.code }}
				</a>
				<v-spacer />
				<!-- <v-btn class="right" small icon v-on="on" @click="$emit('jobStagesClick')">
          <v-icon>mdi-buffer</v-icon>
        </v-btn>-->

				<v-menu offset-y>
					<template v-slot:activator="{ on }">
						<v-btn
							class="right"
							small
							icon
							v-on="on"
							@click="clickSelect(stage.status, block.id)"
						>
							<v-icon>mdi-chevron-double-right</v-icon>
						</v-btn>
					</template>
					<v-list>
						<v-list-item
							v-for="(item, index) in nextStatus"
							:key="index"
							@click="changeStatusManual(block.entityId, item.entityId)"
						>
							<v-list-item-title>{{ item.status }}</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-layout>

			<span class="font-weight-black"
				>{{ $tc("entities.item.title", 1) }}:
			</span>

			<span v-if="block.description && block.description.length < 100">
				<span>{{ block.description }} </span>
			</span>
			<span v-else>
				<span>{{ block.description.substring(0, 100) }}...</span>
			</span>

			<div class="mt-2" v-if="block.obj.account">
				<span class="font-weight-black"
					>{{ $tc("entities.account.title", 1) }}:
				</span>
				{{ block.obj.account.name }}
			</div>

			<div class="mt-2" v-if="block.obj.job.deadline">
				<span class="font-weight-black"
					>{{ $tc("entities.job.props.deadline", 1) }}:
				</span>
				{{ block.obj.job.deadline | dateShortFilter }}
			</div>

			<v-layout>
				<v-layout v-if="obj.totalEstimatedProd && obj.totalEstimatedProd > 0">
					<v-icon class="mt-1" small style="color: green"
						>mdi-marker-check</v-icon
					>
					<div
						class="mr-2 mt-2 ml-1 font-weight-medium text-left text-center"
						style="color: green"
					>
						{{ qtComp.percentualProd.toFixed(2) }}%
					</div>
				</v-layout>
				<v-spacer />
				<status-color
					class="mr-2 mb-2"
					v-if="jobStageStatusComp"
					:color="jobStageStatusComp.color"
					:size="25"
					:hint="jobStageStatusComp.status"
				></status-color>

				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<div
							v-on="on"
							class="caption"
							:style="
								convertCountDown(block.dateCurrentStatus, block.leadTimeMin)
									.isLate
									? 'color:red'
									: 'color:limegreen'
							"
						>
							{{
								convertCountDown(block.dateCurrentStatus, block.leadTimeMin)
									.result
							}}
						</div>
					</template>
					<span>{{ block.dateCurrentStatus | dateFilter }}</span>
				</v-tooltip>
			</v-layout>

			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<!-- <v-btn color="primary" dark v-bind="attrs" v-on="on"> Button </v-btn> -->
					<div class="text-right" v-on="on" v-bind="attrs">
						<v-icon color="blue">mdi-progress-check</v-icon>
						<span color="info" class="font-weight-black">
							{{ qtComp.qtEstimated.toLocaleString() }} /
							{{ qtComp.qtReal.toLocaleString() }}</span
						>
					</div>
				</template>
				<span>Est / Real</span>
			</v-tooltip>
		</v-card-text>
	</v-card>
</template>

<script>
	import moment from "moment";
	import "moment-duration-format";

	export default {
		name: "resource-card-block-kanban",
		props: ["block", "stages", "stage", "environment"],
		data() {
			return {
				obj: {},
				statusSelected: "",
				job: null,
			};
		},
		filters: {
			dateFilter(date) {
				return moment(date).format("DD/MM/YY H:mm");
			},
			dateShortFilter(date) {
				return moment(date).format("DD/MM/YYYY");
			},
		},
		computed: {
			qtComp() {
				let qtEstimated = 0;
				let qtReal = 0;
				let percentualProd = 0;
				let prods = this.block.obj.jobStageItemProds;
				if (!prods) return { qtEstimated, qtReal };

				prods.forEach((p) => {
					if (p.unitId != null) {
						qtEstimated += p.qtEstimated;
					}

					qtReal += p.qtReal;
				});

				percentualProd = (qtReal * 100) / qtEstimated;

				return { qtEstimated, qtReal, percentualProd };
			},
			nextStatus() {
				if (!this.statusSelected) return [];
				return this.stages.filter((s) => s.status != this.statusSelected);
			},
			jobStageStatusComp() {
				if (
					!this.environment.jobStageStatus ||
					this.environment.jobStageStatus.length == 0
				)
					return null;
				let status = this.environment.jobStageStatus.filter(
					(s) => s.status == this.obj.status
				);
				if (status.length > 0) return status[0];
				else return null;
			},
		},
		methods: {
			changeStatusManual(blockId, nextStageId) {
				this.$emit("update-block", {
					blockId,
					nextStageId,
				});
			},

			clickSelect(status, jobSer) {
				this.job = JSON.parse(jobSer);
				this.statusSelected = status;
			},

			convertTimeStatusToHours(date) {
				let statusDate = moment(date);
				let now = moment(Date.now());
				var duration = moment.duration(now.diff(statusDate));
				var hours = moment.duration(duration.asHours(), "h").format("H:mm");
				return hours;
			},

			convertCountDown(date, maxMin) {
				//console.log("date: " + date);
				let hours = this.convertTimeStatusToHours(date);
				if (!maxMin)
					return {
						isLate: false,
						result: "",
					};
				let durationInStatusMili = moment.duration(hours).asMilliseconds();

				//console.log("durationInStatusMili: " + durationInStatusMili);
				let durationMaxsMili = maxMin * 60 * 1000;
				//console.log("durationMaxsMili: " + durationMaxsMili);
				let result = durationMaxsMili - durationInStatusMili;
				//console.log("result: " + result);
				let isLate = result < 0;
				let resultAbs = isLate ? Math.abs(result) : result;
				//console.log("resultAbs: " + resultAbs);

				let resultConv = moment.duration(resultAbs).format("hh:mm");
				//console.log("resultConv:" + resultConv);

				let isHours = resultConv.indexOf(":") >= 0;
				if (durationInStatusMili == 0 && !isHours)
					return {
						isLate: false,
						result: `00:${resultConv}`,
					};

				return {
					isLate: isLate,
					result: isLate ? "-" + resultConv : resultConv,
				};
			},

			isLate(hours, maxMin) {
				let hoursConvert = this.convertTimeStatusToHours(hours);

				if (maxMin == null || maxMin == 0) return false;

				this.convertCountDown(hoursConvert, maxMin);

				let durationHours = moment.duration(hoursConvert).asMinutes();
				console.log(durationHours + " / " + maxMin);
				return durationHours > maxMin;
			},
		},
		mounted() {
			this.obj = JSON.parse(this.block.blockId);
		},
	};
</script>
